<div
  class="wrapper"
  [class.disabled-control]="isEdit && !isEditable"
>
  @if (isPossibleToEdit()) {
    <mat-chip-grid #chipGrid>
      @for (chipsValue of chipsValues; track $index) {
        <mat-chip-row
          id="mat-chip-row"
          [editable]="true"
          (removed)="removeChips(chipsValue)"
          (edited)="editChips($event, chipsValue)"
        >
          {{ chipsValue }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      type="text"
      [matChipInputFor]="chipGrid"
      style="visibility: hidden; display: none"
    >
    <input
      matInput
      color="primary"
      type="text"
      placeholder="Add value..."
      [(ngModel)]="inputValue"
      (keyup.enter)="addChips(inputValue)"
    />
  } @else {
    <div class="value-container">
      {{ this.value }}
    </div>
  }
</div>

